module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousSalesView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('h2', [_vm._v("Enquiry Form")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.salesList.clientName),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "clientName", $$v)
      },
      expression: "salesList.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientContact",
      "name": "clientContact"
    },
    model: {
      value: (_vm.salesList.contactNumber),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "contactNumber", $$v)
      },
      expression: "salesList.contactNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "\tclientAddress",
      "name": "\tclientAddress"
    },
    model: {
      value: (_vm.salesList.corporateAddress),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "corporateAddress", $$v)
      },
      expression: "salesList.corporateAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("\n          Job Type :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s((_vm.JobType.filter(function (x) { return x == true; }).length == 0) ? _vm.JobTypeError : ''))])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _vm._l((_vm.showJobType), function(showJobTypeVal, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": showJobTypeVal.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": showJobTypeVal.value,
        "name": 'JobType' + (index + 1),
        "id": 'JobType' + (index + 1),
        "disabled": _vm.permissionStatus ? true : _vm.checkIsContract
      },
      on: {
        "change": function($event) {
          _vm.JobTypeVal(index, showJobTypeVal.value)
        }
      },
      model: {
        value: (_vm.JobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.JobType, index, $$v)
        },
        expression: "JobType[index]"
      }
    }, [_vm._v(_vm._s(showJobTypeVal.show))])], 1)
  })], 2), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Transport Type"
    },
    model: {
      value: (_vm.salesList.type),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "type", $$v)
      },
      expression: "salesList.type"
    }
  }), _vm._v(" "), (!_vm.salesList.type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.typeError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoPickupLocation"
    }
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.masterList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.AutoPickupLocation),
      callback: function($$v) {
        _vm.AutoPickupLocation = $$v
      },
      expression: "AutoPickupLocation"
    }
  }), _vm._v(" "), (!_vm.salesList.fromLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.fromLocationError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoStuffingLocation"
    }
  }, [_vm._v("Stuffing Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.masterList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    model: {
      value: (_vm.AutoStuffingLocation),
      callback: function($$v) {
        _vm.AutoStuffingLocation = $$v
      },
      expression: "AutoStuffingLocation"
    }
  }), _vm._v(" "), (!_vm.salesList.StuffingLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.StuffingLocationError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoHandoverLocation"
    }
  }, [_vm._v("Handover Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.masterList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.AutoHandoverLocation),
      callback: function($$v) {
        _vm.AutoHandoverLocation = $$v
      },
      expression: "AutoHandoverLocation"
    }
  }), _vm._v(" "), (!_vm.salesList.toLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.toLocationError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "AutoContainerType"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.AutoContainerType),
      callback: function($$v) {
        _vm.AutoContainerType = $$v
      },
      expression: "AutoContainerType"
    }
  })], 1), _vm._v(" "), (_vm.salesList.multipleContainerType.length > 0) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "md-flex": "70"
    }
  }, _vm._l((_vm.salesList.multipleContainerType), function(type, index) {
    return _c('md-chip', {
      key: index,
      attrs: {
        "md-deletable": ""
      },
      on: {
        "delete": function($event) {
          _vm.deleteContainer(type)
        }
      }
    }, [_vm._v(_vm._s(type))])
  })) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transportation Goods Details")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transportDetail",
      "name": "transportDetail",
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract
    },
    model: {
      value: (_vm.salesList.transportDetail),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "transportDetail", $$v)
      },
      expression: "salesList.transportDetail"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.transportDetail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.transportDetailError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Other Details")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherDetail",
      "name": "otherDetail",
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract
    },
    model: {
      value: (_vm.salesList.otherDetail),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "otherDetail", $$v)
      },
      expression: "salesList.otherDetail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "comment",
      "name": "comment",
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract
    },
    model: {
      value: (_vm.salesList.comment),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "comment", $$v)
      },
      expression: "salesList.comment"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Cost Calculator :")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "75"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract,
      "placeholder": "Enquiry date"
    },
    model: {
      value: (_vm.salesList.salesBookingDate),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "salesBookingDate", $$v)
      },
      expression: "salesList.salesBookingDate"
    }
  }), _vm._v(" "), (!_vm.salesList.salesBookingDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.dateError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Driver Expense Per Day")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "driverExpense",
      "name": "driverExpense"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.driverExpense),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "driverExpense", $$v)
      },
      expression: "salesList.driverExpense"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.driverExpense) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.driverExpenseError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Truck average(in km)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "truckAverage",
      "name": "truckAverage"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.truckAverage),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "truckAverage", $$v)
      },
      expression: "salesList.truckAverage"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.truckAverage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.truckAverageError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Distance(in km)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "distance",
      "type": "number",
      "min": "0",
      "name": "distance"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.distance),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "distance", $$v)
      },
      expression: "salesList.distance"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.distance) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.distanceError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No of days")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "noOffDay",
      "name": "noOffDay",
      "type": "number",
      "min": "0"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.noOffDay),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "noOffDay", $$v)
      },
      expression: "salesList.noOffDay"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.noOffDay) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noOffDayError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Toll Prices(in Rs)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "tollPrice",
      "name": "tollPrice"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.tollPrice),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "tollPrice", $$v)
      },
      expression: "salesList.tollPrice"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.tollPrice) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.tollPriceError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Diesel Rate(in Rs.)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "dieselRate",
      "name": "dieselRate",
      "disabled": ""
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.dieselRate),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "dieselRate", $$v)
      },
      expression: "salesList.dieselRate"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.dieselRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.dieselRateError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Base Cost")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "baseCost",
      "name": "baseCost",
      "disabled": ""
    },
    model: {
      value: (_vm.salesList.baseCost),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "baseCost", $$v)
      },
      expression: "salesList.baseCost"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.baseCost) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.baseCostError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Margin(in %)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "quotemargin",
      "name": "quotemargin"
    },
    on: {
      "keyup": function($event) {
        _vm.finalbasecost()
      }
    },
    model: {
      value: (_vm.salesList.quotemargin),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "quotemargin", $$v)
      },
      expression: "salesList.quotemargin"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.quotemargin) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.quotemarginError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Sales Rate")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "quoteSalesCost",
      "name": "quoteSalesCost",
      "disabled": ""
    },
    model: {
      value: (_vm.salesList.quoteSalesCost),
      callback: function($$v) {
        _vm.$set(_vm.salesList, "quoteSalesCost", $$v)
      },
      expression: "salesList.quoteSalesCost"
    }
  })], 1), _vm._v(" "), (!_vm.salesList.quoteSalesCost) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.quoteSalesCostError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color",
    attrs: {
      "disabled": _vm.permissionStatus ? true : _vm.checkIsContract,
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.showQuotation
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop1",
    attrs: {
      "md-content-html": _vm.alert1.content1,
      "md-ok-text": _vm.alert1.ok1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7d5a236","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/sales/leadsBooking.vue
// module id = 2876
// module chunks = 0